import { PrimitiveBlueprint } from "../types";
import { AVATAR_SIZE_CLASSES } from "./sizeClasses";
import { PRIMITIVE_COLORS } from "../../constants";

const SPIDER_COLORS = {
  body: PRIMITIVE_COLORS.darkSlate,
  abdomen: PRIMITIVE_COLORS.slate,
  border: PRIMITIVE_COLORS.darkSlate,
  eye: PRIMITIVE_COLORS.red,
  leg: PRIMITIVE_COLORS.darkSlate,
  shadow: PRIMITIVE_COLORS.darkSlate,
};

export const SPIDER_BLUEPRINT: PrimitiveBlueprint = {
  id: "spider",
  designSize: AVATAR_SIZE_CLASSES.MEDIUM,
  parts: [
    {
      id: "shadow",
      type: "ellipse",
      bounds: { x: 0.1, y: 0.85, w: 0.8, h: 0.15 },
      style: { fill: SPIDER_COLORS.shadow, fillAlpha: 0.3 },
      z: 0,
    },
    {
      id: "abdomen",
      type: "ellipse",
      bounds: { x: 0.35, y: 0.5, w: 0.3, h: 0.35 },
      style: {
        fill: SPIDER_COLORS.abdomen,
        stroke: SPIDER_COLORS.border,
        strokeWidth: 2,
      },
      z: 1,
    },
    {
      id: "body",
      type: "ellipse",
      bounds: { x: 0.35, y: 0.25, w: 0.3, h: 0.3 },
      style: {
        fill: SPIDER_COLORS.body,
        stroke: SPIDER_COLORS.border,
        strokeWidth: 2,
      },
      z: 2,
    },
    {
      id: "eye-top-left",
      type: "ellipse",
      bounds: { x: 0.38, y: 0.3, w: 0.06, h: 0.06 },
      style: { fill: SPIDER_COLORS.eye },
      z: 3,
    },
    {
      id: "eye-top-right",
      type: "ellipse",
      bounds: { x: 0.56, y: 0.3, w: 0.06, h: 0.06 },
      style: { fill: SPIDER_COLORS.eye },
      z: 3,
    },
    {
      id: "eye-bottom-left",
      type: "ellipse",
      bounds: { x: 0.38, y: 0.38, w: 0.06, h: 0.06 },
      style: { fill: SPIDER_COLORS.eye },
      z: 3,
    },
    {
      id: "eye-bottom-right",
      type: "ellipse",
      bounds: { x: 0.56, y: 0.38, w: 0.06, h: 0.06 },
      style: { fill: SPIDER_COLORS.eye },
      z: 3,
    },
    {
      id: "leg-front-left-1",
      type: "line",
      bounds: { x: 0.35, y: 0.35, w: -0.15, h: 0.15 },
      style: { stroke: SPIDER_COLORS.leg, strokeWidth: 2 },
      z: 1,
    },
    {
      id: "leg-front-left-2",
      type: "line",
      bounds: { x: 0.38, y: 0.4, w: -0.12, h: 0.12 },
      style: { stroke: SPIDER_COLORS.leg, strokeWidth: 2 },
      z: 1,
    },
    {
      id: "leg-front-right-1",
      type: "line",
      bounds: { x: 0.65, y: 0.35, w: 0.15, h: 0.15 },
      style: { stroke: SPIDER_COLORS.leg, strokeWidth: 2 },
      z: 1,
    },
    {
      id: "leg-front-right-2",
      type: "line",
      bounds: { x: 0.62, y: 0.4, w: 0.12, h: 0.12 },
      style: { stroke: SPIDER_COLORS.leg, strokeWidth: 2 },
      z: 1,
    },
    {
      id: "leg-back-left-1",
      type: "line",
      bounds: { x: 0.35, y: 0.7, w: -0.15, h: 0.15 },
      style: { stroke: SPIDER_COLORS.leg, strokeWidth: 2 },
      z: 1,
    },
    {
      id: "leg-back-left-2",
      type: "line",
      bounds: { x: 0.38, y: 0.75, w: -0.12, h: 0.12 },
      style: { stroke: SPIDER_COLORS.leg, strokeWidth: 2 },
      z: 1,
    },
    {
      id: "leg-back-right-1",
      type: "line",
      bounds: { x: 0.65, y: 0.7, w: 0.15, h: 0.15 },
      style: { stroke: SPIDER_COLORS.leg, strokeWidth: 2 },
      z: 1,
    },
    {
      id: "leg-back-right-2",
      type: "line",
      bounds: { x: 0.62, y: 0.75, w: 0.12, h: 0.12 },
      style: { stroke: SPIDER_COLORS.leg, strokeWidth: 2 },
      z: 1,
    },
  ],
};
